
<div *ngIf="project$ | async as project; else loading">

  <div *ngIf="viewState === 'form'">
    <h2 class="widget-header" i18n="@@edit-project-infoclass-form-header">Change project information classification</h2>
    <p>
      <span i18n="@@project">Project</span>: <strong>{{project.Name}}</strong>
      <br />
      <span i18n="@@current-infoclass">Current infoclass</span>:
      <span class="font-weight-bold" *ngIf="project.InfoClass === 0" i18n="@@infoclass-k0">Open (K0)</span>
      <span class="font-weight-bold" *ngIf="project.InfoClass === 1" i18n="@@infoclass-k1">Company/project internal information (K1)</span>
      <span class="font-weight-bold" *ngIf="project.InfoClass === 2" i18n="@@infoclass-k2">Less sensitive company/project internal information (K2)</span>
      <span class="font-weight-bold" *ngIf="project.InfoClass === 3" i18n="@@infoclass-k3">Sensitive company/project internal information (K3)</span>
    </p>

    <hr />

    <form [formGroup]="formGroupInfoclass">

      <mat-radio-group formControlName="InfoClass" [(ngModel)]="selectedInfoClass">

        <div [class]="setInfoClassCssClass(1)">
          <mat-radio-button class="" [value]="1">
            <strong i18n="Create Site - Infoclass @@group-infoclass-1">Confidentiality: K1 - Open</strong>
            <ul i18n="Create Site - Infoclass @@group-infoclass-1-help">
              <li>Information may be spread outside of RISE.</li>
              <li>Should information be destroyed, manipulated or end up on the Internet, RISE and/or our customers are not affected.</li>
              <li>Entire organization has read access.</li>
              <li>Only approved members (internal and external) added to the project area can edit.</li>
              <li>On closure: Whole organization and external project members can read. Owners retain edit permission. Edit possibilities in Teams (if any) are removed.</li>
              <li>On archiving: Edit permission for owners is removed. Whole organization can read. External project members are removed.</li>
            </ul>
          </mat-radio-button>
        </div>

        <div [class]="setInfoClassCssClass(2)">
          <mat-radio-button class="" [value]="2">
            <strong i18n="Create Site - Infoclass @@group-infoclass-2">Confidentiality: K2 - Internal</strong>
            <ul i18n="Create Site - Infoclass @@group-infoclass-2-help">
              <li>Information should not be spread outside of the project.</li>
              <li>Should information be destroyed, manipulated or end up on the Internet, harm is manageble for RISE and/or our customers.</li>
              <li>Unauthorized spread can cause moderate harm to individuals, RISE's brand and/or RISE's business.</li>
              <li>Only approved members (internal and external) added to the project area can read/write.</li>
              <li>On closure: Whole organization and external project members can read. Owners retain edit permission. Edit possibilities in Teams (if any) are removed.</li>
              <li>On archiving: Edit permission for owners is removed. Internal project members can read. External project members are removed.</li>
            </ul>
          </mat-radio-button>
        </div>

        <div [class]="setInfoClassCssClass(3)">
          <mat-radio-button class="" [value]="3">
            <strong i18n="Create Site - Infoclass @@group-infoclass-3">Confidentiality: K3 - Sensitive</strong>
            <ul>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-1">Projects using RISE standard NDA are usually handled as K3. For more information <a href="https://risecloud.sharepoint.com/sites/sakerhet/SitePages/Informationsklassning.aspx" target="_blank">click here</a>.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-2">If project is classified higher than K3 (e.g. custom NDA) it should not be managed through PDP. <a href="https://risecloud.sharepoint.com/sites/services/SitePages/Fillagring.aspx" target="_blank">Click here</a> for information on how to obtain K4 storage.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-3">Information must not be spread outside of the project.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-4">Should information be destroyed, manipulated or end up on the Internet, RISE's and/or customer brands may be harmed, fines for GDPR violations may occur.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-5">Unauthorized spread can cause significant harm to RISE's brand and/or RISE's business.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-6">Only approved members (internal and external) added to the project area can read/write.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-7">On closure: Project members can read. Owners retain edit permission. Edit possibilities in Teams (if any) are removed.</li>
              <li i18n="Create Site - Infoclass @@group-infoclass-3-help-8">On archiving: Edit permission for owners is removed. Internal project members can read. External project members are removed.</li>
            </ul>
          </mat-radio-button>
        </div>
      </mat-radio-group>

    </form>


    <button mat-button mat-flat-button class="cancel-button mt-5 mr-2" [routerLink]="'/'" type="button" i18n="@@cancel">Cancel</button>
    <button mat-button mat-flat-button color="primary" class="mt-4" [disabled]="selectedInfoClass === project.InfoClass" (click)="updateProject()" type="button" i18n="@@save">Save</button>
  </div>

  <div *ngIf="viewState === 'working'">
    <div class="text-center mt-6">
      <p><mat-spinner [diameter]="25" style="margin: 0 auto;"></mat-spinner></p>
      <p i18n="@@saving">Saving...</p>
    </div>
  </div>

  <div *ngIf="viewState === 'ready'">
    <div class="text-center mt-6">
      <p>
        <i aria-hidden="true" class="ready-check ms-Icon ms-Icon--SkypeCircleCheck align-middle"></i>
        &nbsp;
        <strong>{{project.Name}}</strong>&nbsp;<span i18n="@@has-been-updated">has been updated!</span>
      </p>
      <p class="mt-5">
        <a i18n="@@back-to-project-list" [routerLink]="'/'">Return to the project list.</a>
      </p>
    </div>
  </div>

  <div *ngIf="viewState === 'error'">
    <div class="text-center mt-6">
      <p>
        <i aria-hidden="true" class="error-icon ms-Icon ms-Icon--StatusErrorFull align-middle"></i>
        &nbsp;
        <span i18n="@@something-went-wrong">Something went wrong. Please try again or contact support!</span>
      </p>
      <p>
        <small>{{errorMessage}}</small>
      </p>
    </div>
  </div>

</div>


<ng-template #loading>
  <div class="text-center mt-6">
    <p><mat-spinner [diameter]="25" style="margin: 0 auto;"></mat-spinner></p>
  </div>
</ng-template>

